import { render, staticRenderFns } from "./charge-detail.vue?vue&type=template&id=49e18d64&scoped=true&"
import script from "./charge-detail.vue?vue&type=script&lang=js&"
export * from "./charge-detail.vue?vue&type=script&lang=js&"
import style0 from "./charge-detail.vue?vue&type=style&index=0&id=49e18d64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e18d64",
  null
  
)

export default component.exports